import { createContext } from 'react';
import { DispatchApplicationAction } from '../actions';

export const ApplicationDispatchContext = createContext<DispatchApplicationAction | undefined>(undefined);
